import { useEffect } from "react";
import { useLocation } from "react-router";
import { useInitAltenar } from "../lib/use-init-altenar";
import { useCurrentLanguage } from "../../../shared/lib";
import { useAltenarStore } from "../../../entities/altenar-service";

export const AltenarSportProvider = () => {
	const altenarStore = useAltenarStore();
	const root = document.getElementById("root");
	const altenarTag = document.getElementById("altenar");
	const { pathname } = useLocation();
	const lang = useCurrentLanguage();

	const culture =
		(lang === "ar" && "ar-AR") ||
		(lang === "fr" && "fr-FR") ||
		(lang === "fa" && "fa-IR") ||
		(lang === "de" && "de-DE") ||
		(lang === "tr" && "tr-TR") ||
		(lang === "hr" && "hr-HR") ||
		(lang === "sr" && "sr-RS") ||
		"en-GB";

	useInitAltenar({ culture });
	useEffect(() => {
		if (altenarStore) altenarStore.updateSB({ culture });
	}, [culture]);

	useEffect(() => {
		if (
			!(pathname.includes("/sport") || pathname.includes("/live-sport"))
		) {
			if (altenarStore && altenarStore.altSportBook) altenarStore.clean();
			altenarTag!.hidden = true;
		} else {
			root!.style.height = "auto";
			altenarTag!.hidden = false;
		}

		window.scrollTo(0, 0);
		return () => {
			if (root) root.style.height = "100%";
		};
	}, [pathname]);

	return null;
};
